<template>
	<v-form>
      	<v-container fluid>
			<v-row >
				<v-col>
					<p class="display-1">
						Period Revenue Report
					</p>
				</v-col>
			</v-row>
        	<v-row >
          		<v-col class="pb-0" cols="12" sm="6" >
					<a-hotel-select v-model="hotelCode"
								 :hotels="hotels"
								 @change="changeHotel"
								 solo>
					</a-hotel-select>
				</v-col>
        	</v-row>
        	<v-row >
          		<v-col class="pt-0" sm="12" md="6" >
					<v-subheader>С</v-subheader>
					<v-date-picker 	v-model="dateFrom"
									:landscape="$vuetify.breakpoint.mdAndUp"
									:reactive="true"
									scrollable
									first-day-of-week="1"
									locale="ru-ru"
									:show-current="false"
									:max="maxDate"
									full-width>
					</v-date-picker>
				</v-col>
          		<v-col class="pt-0" sm="12" md="6" >
					<v-subheader>По</v-subheader>
					<v-date-picker 	v-model="dateTo"
									:landscape="$vuetify.breakpoint.mdAndUp"
									:reactive="true"
									scrollable
									first-day-of-week="1"
									locale="ru-ru"
									:show-current="false"
									:max="maxDate"
									full-width>
					</v-date-picker>
				</v-col>
	        </v-row>
			<v-row >
				<v-col class="py-0" >
					<v-radio-group v-model="showChart" row>
						<template v-slot:label>
		        			<div style="width: 100px">Показать:</div>
		      			</template>
						<v-radio label="График выручки" value="1"></v-radio>
						<v-radio label="Проданные номера и каверсы" value="0"></v-radio>
					</v-radio-group>
				</v-col>
        	</v-row>
			<v-row>
				<v-col class="pl-1" cols="12" >
					<v-btn color="primary" @click="combine">Сформировать</v-btn>
				</v-col>
			</v-row>
    	</v-container>
	</v-form>
</template>

<script>
	import aHotelSelect from '../base/AHotelSelect.vue'
	import dateFormat from 'dateformat'
	import {api} from '../../lib/api'
	import {display} from '../../lib/display'

	export default {
		components: {
			aHotelSelect
		},
		data: () => ({
			hotelCode: '',
			hotels: null,
			dateFrom: "",
			dateTo: "",
			showChart: "1"
		}),
		computed: {
			selected() {
				return this.hotels.map(hotel => (hotel.code || null)).indexOf(this.hotelCode)
			},
			maxDate() {
				return this.hotels[this.selected].maxDate
			}
		},
		created() {
			if (this.$store.getters.userHo) {
				this.hotels = this.$store.getters.allHotels
			}
			else {
				this.hotels = this.$store.getters.userHotels
			}

			this.hotelCode = this.hotels[0].code

			api.post('drr/get_last_report_date', { hotels: this.hotels })
			.then(response => {
				this.hotels = response.data.hotels
				this.hotels = this.hotels.map(hotel => {
					hotel.selectedDate = ""
					return hotel
				})

				let selHotelCode = this.$store.getters.selectedHotelCode

				if (selHotelCode && this.hotels.find(el => el.code == selHotelCode)) {
					this.hotelCode = selHotelCode
				}
				else {
					this.$store.dispatch('setSelectedHotelCode', this.hotelCode)
				}

				this.changeHotel()
			}, error => {})
		},
		methods: {
			changeHotel() {
				this.dateTo = this.maxDate
				let d = Date.parse(this.dateTo)
				d = d - 1900800000 // 22 * 24 * 60 * 60 * 1000 = 22 дня
				this.dateFrom = dateFormat(d, "yyyy-mm-dd")
			},
			combine() {
				display.open({
					reportCode: 'prr',
					userId: this.$store.getters.userId,
					hotelCode: this.hotelCode,
					reportDateFrom: this.dateFrom,
					reportDateTo: this.dateTo,
					showChart: this.showChart
				})
			}
		}
	}
</script>
